import React, { useEffect, useMemo, useState } from 'react';
import StoreKpiCards from './StoreKpiCards';
import StoreKpiChart from './StoreKpiChart';
import { useStoreForecasts, useStoreHistory } from '../../hooks/useStoresData';
import { storeChartData, storeForecastRows, storeKpiCards } from '../../utils/storeKpis';

/**
 * 店舗の KPI カード ＋ KPI ごとのグラフ。カードのタップとプルダウンが、同じ「選んでいる指標」を切り替える。
 * entry = store-summary の 1 店舗分。履歴と予測は、店舗単位（stylist 指定なし）で取る。
 * 予測が取れなくても（まだ無い・失敗）、実績のグラフは出る。
 */
export default function StoreKpiSection({ entry, selectedMonth }) {
  const store = entry?.store;
  const history = useStoreHistory(store);
  const forecasts = useStoreForecasts(store);
  const [metricKey, setMetricKey] = useState('revenue');

  const cards = useMemo(() => storeKpiCards(entry, selectedMonth), [entry, selectedMonth]);
  const chart = useMemo(
    () =>
      storeChartData({
        entry,
        history: history.data?.history,
        forecasts: storeForecastRows(forecasts.data?.forecasts),
        selectedMonth,
      }),
    [entry, history.data, forecasts.data, selectedMonth]
  );

  // 選んでいる指標が、この店舗のグラフに無いとき（データが無い指標）は、先頭に戻す
  useEffect(() => {
    if (chart.metricOrder.length && !chart.metricOrder.includes(metricKey)) setMetricKey(chart.metricOrder[0]);
  }, [chart.metricOrder, metricKey]);

  return (
    <>
      <StoreKpiCards
        cards={cards}
        metricKey={metricKey}
        availableMetrics={chart.metricOrder}
        onPick={setMetricKey}
        headcount={entry?.stylist_count}
      />
      <StoreKpiChart
        data={chart}
        metricKey={metricKey}
        onChange={setMetricKey}
        loading={history.loading}
        error={history.error}
      />
    </>
  );
}
